<template>
  <div class="chat-dialog">
    <el-dialog
      :visible.sync="$store.state.imGroup.dialogShow"
      custom-class="previewDialog"
      width="70%"
      :title="$t('Message.ChatWindow')"
      :before-close="handleClose"
    >
      <i class="el-icon-close close" @click="handleClose" />
      <div
        v-loading="loadingChat"
        style="height:100%;"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
      >
        <iframe
          ref="myiframe"
          style="border:none;border-radius: 10px;"
          :src="imUrl"
          scrolling="no"
          width="100%"
          height="100%"
        />
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data() {
    return {
      imUrl: '',
      loadingText: '',
      loadingChat: false
    }
  },
  watch: {
    '$store.state.imGroup.groupIdList': {
      handler(value) {
        const myiframe = this.$refs['myiframe']
        const contentWindow = myiframe.contentWindow
        console.log('需要传给im的群组id22222', value)
        value.type = 'caargoware'
        value.openType = '1'
        value.personnelIncrease = new Date().valueOf()
        contentWindow.postMessage(value, '*')
      },
      deep: true
    }
  },
  methods: {
    handleClose() {
      this.$store.commit('DIALOG_SHOW', false)
      const myiframe = this.$refs['myiframe']
      const contentWindow = myiframe.contentWindow
      const data = {
        closeType: '1',
        type: 'caargoware'
      }
      contentWindow.postMessage(data, '*')
    },
    open(imUrl) {
      this.imUrl = imUrl
    }
  }
}
</script>

<style lang="scss">

.chat-dialog{
  .previewDialog{
    .el-dialog {
      .dj-dialog-content {
        padding: 0;
        overflow: unset;
      }
    }
  }
  .el-dialog{
    height: 700px;
    display: flex;
    border-radius: 10px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    margin: 0 !important;
    .el-dialog__body{
      flex: 1;
      padding: 0;
    }
    .el-dialog__header{
      display: none;
    }
    .el-loading-text{
      font-size: 18px;
    }
    .el-loading-spinner i{
      font-size: 30px;
    }
    .close{
      position: absolute;
      right: 13px;
      top: 13px;
      font-size: 24px;
      display:flex;
      align-items: center;
      justify-content: center;
      width: 15px;
      height: 15px;
      cursor: pointer;
    }
  }
  .el-dialog__wrapper {
    transition-duration: 0.3s;
  }

  .dialog-fade-enter-active .el-dialog,
  .dialog-fade-leave-active .el-dialog{
    animation-fill-mode: forwards;
  }
  .dialog-fade-enter-active .el-dialog{
    animation-duration: 0.3s;
    animation-name: anim-open;
  }
  .dialog-fade-leave-active .el-dialog{
    animation-duration: 0.3s;
    animation-name: anim-close;
  }
  @keyframes anim-open {
    0% {
      opacity: 0;
      top: 20%;
    }
    100% {
      opacity: 1;
      top: 50%;
    }
  }
  @keyframes anim-close {
    0% {
      opacity: 1;
      top: 50%;
    }
    100% {
      opacity: 0;
      top: 20%;
    }
  }
  .transition-box {
    margin-bottom: 10px;
    width: 200px;
    height: 100px;
    border-radius: 4px;
    background-color: #409EFF;
    text-align: center;
    color: #fff;
    padding: 40px 20px;
    box-sizing: border-box;
    margin-right: 20px;
  }
}

</style>
